/* eslint-disable react-hooks/exhaustive-deps */
import {
    IonContent,
    IonPage,
    useIonViewDidEnter,
    IonLoading,
    IonAlert,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
} from '@ionic/react'
import React, { useState, useEffect, useRef } from 'react'
import Header from './components/Header'
import KnowledgeList from './components/KnowledgeList'
import {
    getKnowledgeList,
    deleteKnowledge,
    PaginationModel,
} from '../../service/api/knowledge'
import { useSelector } from 'react-redux'
import { ReduxStore } from '../../redux/reducers'
import { UserModel } from '../../model/user.model'
import './index.css'
import Toast, { ToastProps } from '../../components/Toast'
import { KnowledgeModel } from '../../model/knowledge.model'
import { useHistory } from 'react-router'
import EmptyMsg from '../../components/EmptyMsg'
import { KnowledgeDetailPage } from '../../conf/routePath'

interface LoadingProps {
    isOpen: boolean
    onDidDismiss?: () => void
    message?: string
    duration?: number
}
const MyKnowledge: React.FC = () => {
    const history = useHistory()
    const userInfo = useSelector<ReduxStore, UserModel>(
        (store) => store.userInfo as UserModel
    )
    const [knowledgeList, setKnowledgeList] = useState<KnowledgeModel[]>([])
    const [toastOptions, setToastToastOptions] = useState<ToastProps>({
        isOpen: false,
        message: '',
        color: 'error',
        duration: 1500,
    })
    const [loadingOptions, setLoadingOptions] = useState<LoadingProps>({
        isOpen: false,
        message: '加载中...',
    })
    const [knowledgeIsDeletting, setKnowledgeIsDeletting] = useState(false)
    const [
        delettingKnowledge,
        setDelettingKnowledge,
    ] = useState<KnowledgeModel | null>(null)
    const ionInfiniteScroll = useRef<any>(null)
    const [pagination, setPagination] = useState<PaginationModel>({
        page: 1,
        page_size: 20,
    })
    const [noMore, setNoMore] = useState(false)
    const [alertOptions, setAlertOptions] = useState({
        isOpen: false,
        onDidDismiss: () => {
            setAlertOptions({
                ...alertOptions,
                isOpen: false,
            })
        },
        message: '确定要删除该知识点吗？',
    })
    useIonViewDidEnter(() => {
        setPagination({
            ...pagination,
            page: 1,
        })
    })
    useEffect(() => {
        queryKnowledgeList(pagination)
    }, [pagination])

    /** 查询自定义分类下的知识点列表 */
    const queryKnowledgeList = async (pager: PaginationModel) => {
        if (pager.page === 1) {
            setLoadingOptions({
                isOpen: true,
            })
            setNoMore(false)
        }
        try {
            let list: KnowledgeModel[] = []
            let res = await getKnowledgeList({
                appHash: userInfo.app_hash,
                pagination: pager,
                tagId: userInfo.custom_tag_id,
            })
            list = res.data.getKnowledgeList.rows

            // 如果大于1页，则表示加载更多
            if (pager.page > 1) {
                setKnowledgeList([...knowledgeList, ...list])
            } else {
                setKnowledgeList(list)
            }
            if (list.length < pagination.page_size) {
                setNoMore(true)
            }
        } catch (error) {
            setToastToastOptions({
                ...toastOptions,
                isOpen: true,
                color: 'error',
                message: '服务器异常',
            })
        }
        if (ionInfiniteScroll !== null && ionInfiniteScroll.current !== null) {
            ionInfiniteScroll.current.complete()
        }

        setLoadingOptions({
            isOpen: false,
        })
    }
    const handleKnowledgeItemClick = (knowledge: KnowledgeModel) => {
        /** 删除知识点 */
        if (knowledgeIsDeletting) {
            setDelettingKnowledge(knowledge)
            setAlertOptions({
                ...alertOptions,
                isOpen: true,
            })
            return
        }
        handleKnowledgeEdit(knowledge)
    }
    const handleKnowledgeEdit = (knowledge: KnowledgeModel) => {
        /** 编辑知识点 */
        history.push(KnowledgeDetailPage, {
            knowledge,
        })
    }
    /** 添加知识点 */
    const handleKnowledgeAdd = () => {
        history.push(KnowledgeDetailPage, {
            ktag_id: userInfo.custom_tag_id,
        })
    }
    /** 删除知识点 */
    const handleKnowledgeDelete = async (knowledge: KnowledgeModel) => {
        try {
            let res = await deleteKnowledge({
                kId: knowledge.k_id,
                appHash: userInfo.app_hash,
            })
            if (res.data.deleteKnowledge.successfully) {
                setPagination({
                    ...pagination,
                    page: 1,
                })
            } else {
                setToastToastOptions({
                    ...toastOptions,
                    isOpen: true,
                    color: 'error',
                    message: res.data.deleteKnowledge.error.detail,
                })
            }
        } catch (error) {}
    }
    return (
        <IonPage className='my-knowledge-page'>
            <IonContent className='content'>
                <Header
                    deleteable={knowledgeList.length > 0}
                    onAdd={handleKnowledgeAdd}
                    isDeletting={knowledgeIsDeletting}
                    onDeleteComplete={() => setKnowledgeIsDeletting(false)}
                    onDelete={() => setKnowledgeIsDeletting(true)}
                />
                <KnowledgeList
                    className='knowledge-list-wrapper'
                    isDeletting={knowledgeIsDeletting}
                    dataSource={knowledgeList}
                    onItemClick={handleKnowledgeItemClick}
                />
                {!noMore && knowledgeList.length > 0 && (
                    <IonInfiniteScroll
                        threshold='60px'
                        ref={ionInfiniteScroll}
                        onIonInfinite={(e) =>
                            setPagination({
                                ...pagination,
                                page: pagination.page + 1,
                            })
                        }
                    >
                        <IonInfiniteScrollContent
                            loadingSpinner='bubbles'
                            loadingText='加载更多...'
                        ></IonInfiniteScrollContent>
                    </IonInfiniteScroll>
                )}
                <EmptyMsg
                    show={knowledgeList.length === 0 && !loadingOptions.isOpen}
                >
                    暂无知识，点击右上角添加知识吧！
                </EmptyMsg>
            </IonContent>
            <Toast
                {...toastOptions}
                onClose={() =>
                    setToastToastOptions({ ...toastOptions, isOpen: false })
                }
            />
            <IonAlert
                {...alertOptions}
                buttons={[
                    {
                        text: '取消',
                        handler: () => {
                            setAlertOptions({
                                ...alertOptions,
                                isOpen: false,
                            })
                        },
                    },
                    {
                        text: '确认',
                        handler: () => {
                            setAlertOptions({
                                ...alertOptions,
                                isOpen: false,
                            })
                            delettingKnowledge &&
                                handleKnowledgeDelete(delettingKnowledge)
                        },
                    },
                ]}
            />
            <IonLoading {...loadingOptions} />
        </IonPage>
    )
}

export default MyKnowledge
